import { ChangeDetectorRef, Component, Input } from '@angular/core'
import { ProductListComponentService, ProductScrollComponent } from '@spartacus/storefront'
import { EbProduct, EbProductSearchPage } from '../../interfaces/eb-product.interface'

@Component({
    selector: 'eb-product-scroll',
    templateUrl: './eb-product-scroll.component.html',
    styleUrls: ['./eb-product-scroll.component.scss'],
    standalone: false
})
export class EbProductScrollComponent extends ProductScrollComponent {
  model: EbProductSearchPage
  isFuzzyProductModel = false
  @Input('model')
  set setModel(inputModel: EbProductSearchPage) {
    this.isFuzzyProductModel = inputModel.fuzzyProducts?.length > 0
    this.ebInfiniteScrollOperations(inputModel)
  }

  constructor(
    productListComponentService: ProductListComponentService,
    ref: ChangeDetectorRef,
    protected ebRef: ChangeDetectorRef
  ) {
    super(productListComponentService, ref)
  }

  getProducts(productListModel: EbProductSearchPage): EbProduct[] {
    if (productListModel && productListModel.products?.length > 0) {
      return productListModel.products
    } else if (productListModel && productListModel.fuzzyProducts) {
      return productListModel.fuzzyProducts
    }
  }

  private ebInfiniteScrollOperations(inputModel: EbProductSearchPage): void {
    if (this.appendProducts) {
      this.model = {
        ...inputModel,
        products: this.model.products?.concat(inputModel.products),
        fuzzyProducts: this.model.fuzzyProducts?.concat(inputModel.fuzzyProducts)
      }
    } else {
      this.model = inputModel
      this.maxProducts = this.productLimit
    }
    this.ebSetConditions()
    this.ebRef.markForCheck()
  }

  // Set booleans after model has been retrieved
  private ebSetConditions(): void {
    this.isEmpty = this.isFuzzyProductModel
      ? !this.model.fuzzyProducts || this.model.fuzzyProducts.length === 0
      : !this.model.products || this.model.products.length === 0
    this.isLastPage = this.model.pagination.currentPage === this.model.pagination.totalPages - 1

    this.isMaxProducts = this.isFuzzyProductModel
      ? this.productLimit &&
        this.productLimit !== 0 &&
        this.model.fuzzyProducts?.length >= this.maxProducts
      : this.productLimit &&
        this.productLimit !== 0 &&
        this.model.products?.length >= this.maxProducts

    // Add the productLimit to the current number of products to determine the next max number of products
    if (this.isMaxProducts) {
      this.maxProducts = this.isFuzzyProductModel
        ? this.model.fuzzyProducts?.length + this.productLimit
        : this.model.products?.length + this.productLimit
    }

    // Only change viewMode once the new model is set
    // This prevents flickering issues
    if (this.viewMode !== this.inputViewMode) {
      this.viewMode = this.inputViewMode
    }

    this.resetList = false
    this.appendProducts = false
  }
}
